import React from "react"
import LandingHeader from "components/Atoms/LandingHeader"
import clsx from "utils/clsx"
import Landing from "assets/images/landing.png"

type StaticPageType = {
  title?: string
  children?: React.ReactNode
  className?: string
  containerClassName?: string
}
const StaticPage = ({
  title,
  children,
  className,
  containerClassName,
}: StaticPageType) => {
  return (
    <div
      style={{
        backgroundImage: `url(${Landing})`,
      }}
      className={clsx(
        "h-screen flex flex-col bg-no-repeat bg-cover",
        className
      )}
    >
      <LandingHeader />
      <div
        className={clsx(
          "container py-4 text-md text-gray-700 flex justify-center grow text-lg",
          containerClassName
        )}
      >
        {title && <h3>{title}</h3>}
        {children}
      </div>
    </div>
  )
}

export default StaticPage
